import { dayjs } from '@/time';

export const SIZE = 20;

export const LAST_100_DAYS = dayjs()
  .subtract(100, 'day')
  .startOf('day')
  .toDate()
  .valueOf();

export const LAST_14_DAYS = dayjs()
  .subtract(14, 'day')
  .startOf('day')
  .toDate()
  .valueOf();

export const LAST_3_DAYS = dayjs()
  .subtract(3, 'day')
  .startOf('day')
  .toDate()
  .valueOf();

export const TODAY_AS_NUMBER = dayjs().startOf('day').toDate().valueOf();

export const TODAY = TODAY_AS_NUMBER;

export const MAX_POST_PREVIEW_LENGTH = 100;
export const MIN_NUMBER_OF_COMMENTS = 5;

export const MAX_COMMENT_LENGTH = 5000;
